import { InjectionToken } from "@angular/core";

export const LAST_HERO_SETTINGS_TOKEN = new InjectionToken<any>('LAST_HERO_SETTINGS');
export const LAST_HERO_ACCORDION_SETTINGS_TOKEN = new InjectionToken<any>('LAST_HERO_ACCORDION_SETTINGS');

export const LAST_HERO_SETTINGS_PROVIDER = {
    provide: LAST_HERO_SETTINGS_TOKEN,
    useFactory: () => {
        return {
            qualifiedTaxDeductible: true,
            isDefault: false,
            dedicationEnabled: false,
            streetAddress: false,
            phoneNumber: false,
            additionalInfo: false,
            additionalInfoSelect: false,
            coCampaigns: false,
            addOnDonationCampaign: false,
            redirectUrl: false,
            donationButtonLabel: false,
            internalId: true,
            campaignPageImage:true
        };
    }
};

export const LAST_HERO_ACCORDION_SETTINGS_PRODVIDER = {
    provide: LAST_HERO_ACCORDION_SETTINGS_TOKEN,
    useFactory: () => {
        return {
            general: {
                expanded: false
            },
            coverFee: {
                expanded: false
            },
            eMail: {
                expanded: false
            },
            settings: {
                expanded: false
            }
        };
    }
};
